import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getAllAreas = (user) => {
  return requestWithPromise(
    '/api/areas',
    HttpMethods.GET,
    null,
    user
  )
}

export const getAllAreasPublic = () => apiClient.get(null, 'public/areas')
